import React, { useReducer, useCallback } from 'react'
import { PetsState, Pet } from '../types'
import { pets } from '../reducers/pets'
import { setNewPets } from '../actions/pets'
import { removePreviousPets } from '../utils/removePreviousPets'

const defaultContextValue = {
  pets: [] as PetsState,
  setPetsValue: (pets: PetsState) => {},
  handleRemovePreviousPets: ({
    index,
    pets,
    petList
  }: {
    index: number
    pets: PetsState
    petList: Pet[]
  }) => {}
}
const initialState: PetsState = []

export const PetsContext = React.createContext(defaultContextValue)

export const PetsProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(pets, initialState)

  const setPetsValue = useCallback((newPets: PetsState) => {
    dispatch(setNewPets(newPets))
  }, [])

  const value = {
    pets: state,
    setPetsValue,
    handleRemovePreviousPets: ({
      index,
      pets,
      petList
    }: {
      index: number
      pets: PetsState
      petList: Pet[]
    }) => {
      const petsLeft = removePreviousPets({
        index,
        pets,
        petList
      })
      dispatch(setNewPets(petsLeft))
    }
  }

  return <PetsContext.Provider value={value}>{children}</PetsContext.Provider>
}
